import '../css/Verify.css'
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import "../css/Nav design.css";
import TopBar from './TopBar';
import { useEffect, useState } from 'react';
import OtpRequest from '../model/request/OtpRequest';
import ApiConfig from '../utils/ApiConfig';
import axios from 'axios';
import ApiResponse from '../model/response/ApiResponse';
import { ToastContainer, toast } from "react-toastify";
import { getFCMToken } from "../utils/fcm";
import { requestForToken } from "../firebase";


function Verify() {
  var location = useLocation();
  var { userId, isFromRegistration, isFromForgot, mobileNumber, mobile, isOtpLogin } = location.state || {};

  console.log(location.state);

  //   const mobileNumber = location.state?.mobileNumber;
  // const mobile = location.state?.mobile;
  // const isOtpLogin = location.state?.isOtpLogin;
  // var userObject = Object.setPrototypeOf(userRegister,UserRegister.prototype);   
  const navigation = useNavigate()
  // var userRegister= new UserRegister();

  var [code, setCode] = useState("");
  var [codeError, setCodeError] = useState();
  const [timer, setTimer] = useState(0);
  const [isResendDisabled, setIsResendDisabled] = useState(false);
  const [fcmToken, setFcmToken] = useState("");





  const rawVal = localStorage.getItem('loginVal');
  let loginVal = rawVal ? JSON.parse(rawVal) : null;
  let token = loginVal ? loginVal.token : null;



  function clicktoViewpagescreen() {
    if (validation()) {
      verifyOtpAPICall();
      
    }
  }

  function validation() {
    var isFlage = true

    if (code == "") {
      setCodeError("Please Verify Your Code.")
      isFlage = false
    }
    else {

      setCodeError("")

    }
    return isFlage;

  }

  function showToast(message) {
    toast.success(message, {
      position: "top-right",
      autoClose: 2000
    });
  }


  function showToastFailed(message) {
    toast.error(message, {
      position: "top-right",
      autoClose: 2000
    });
  }
  useEffect(() => {

    fetchFCMToken();
    const token = localStorage.getItem("token");

    console.log("isFromRegistration", isFromRegistration);
    if (isOtpLogin) {

      return;
    }
    if (token) {
      navigation("/Viewpage", { replace: true });
    }
    if (isFromForgot) {
      return;
    }

    if (!isFromRegistration && token) {
      navigation('/Viewpage');
    }
    if (!isFromRegistration && (token == null || token == "")) {
      navigation('/login');
    }
    let interval;

    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else {
      setIsResendDisabled(false);
    }

    return () => clearInterval(interval);

     
    

  }, [isFromRegistration, isFromForgot, isOtpLogin, timer, token, navigation]);


 const fetchFCMToken = async () => {
    try {
      const permission = await Notification.requestPermission();
      // if (permission !== "granted") {
      // console.error("Notification permission denied by user.");
      // return;
      // }
      const token = await requestForToken();

      if (token) {
        console.log("FCM Token:", token);
        setFcmToken(token);
      }
    } catch (err) {
      console.log(err);
    }
  };


  function verifyOtpAPICall() {
    var request = new OtpRequest();
    request.userId = userId;
    request.otp = code;
    request.type = 0;
    request.fcmToken = fcmToken
    console.log("Response:", JSON.stringify(request));
    axios.post(
      ApiConfig.getUrl("User/verifyOTP"),
      JSON.stringify(request),
      {
        headers: {
          "Content-Type": "application/json",
        }
      }
    )
      .then(response => {

        const api = ApiResponse.fromJson(response.data);
        console.log("Response:", api);
        if (api.status == true && api.statusCode == 200) {
          showToast("OTP Verified successfully!.")


           localStorage.setItem("token", api.response.token);
          localStorage.setItem("loginVal", JSON.stringify(api.response));
          if (isOtpLogin) {

            navigation("/Viewpage", { replace: true });
            return;
          }
          if (isFromForgot) {

            navigation('/Resetpassword', {
              state: {
                userId: userId,
                isFromForgot: true
              }
            });

          } else {

            setTimeout(() => {
              navigation("/Viewpage", { replace: true });
            }, 100);
          }




        } else {
          showToastFailed("Invalid OTP")
        }
      })
      .catch(error => {
        console.error("Error:", error);
      });
  }


  function resendOtpAPICall() {
    var request = new OtpRequest();
    request.userId = userId;
    request.message = "OTP resend successfully!.";
    console.log("Response:", JSON.stringify(request));
    axios.post(
      ApiConfig.getUrl("User/sendSMSOTP"),
      JSON.stringify(request),
      {
        headers: {
          "Content-Type": "application/json",
        }
      }
    )
      .then(response => {

        const api = ApiResponse.fromJson(response.data);
        console.log("Response:", api);
        if (api.status == true && api.statusCode == 200) {
          showToast("OTP resend successfully!.");
          setIsResendDisabled(true);
          setTimer(60);


        } else {
          showToastFailed("Resend OTP Failed")
        }
      })
      .catch(error => {
        console.error("Error:", error);
      });
  }




  const disableRightClick = (e) => {
    e.preventDefault();
  };

  return (
    <>
      <div onContextMenu={disableRightClick}>
        <TopBar />
        <ToastContainer />

        <div className='fullview' style={{ backgroundColor: 'white' }}>

          <div className="card  h-100 w-100s" >
            <p className="h5 text-center mt-2 pt-2">OTP Verification</p>
            <p className="h6 text-center ">Enter the 4-digit code sent to your Mobile Number</p>

            <div className="otp-input mt-2 ms-1 ">
              <input type="number" max="1" required value={code} onChange={(e) => setCode(e.target.value)} />


            </div>
            <div style={{ display: "flex", justifyContent: "center", position: "relative" }}>

              <button onClick={clicktoViewpagescreen} type="button" className='btn' style={{ background: "var(--primary-color)", fontWeight: "bold" }} >Verify</button>
            </div>
            <span  className="mt-2 text-danger text-decoration-none center" style={{ letterSpacing: "1px" }} >{codeError}</span>
            <p className="h6 text-center">
              Didn't receive code yet?{" "}

              <span
                onClick={!isResendDisabled ? resendOtpAPICall : undefined}
                style={{
                  color: isResendDisabled ? "gray" : "orange",
                  cursor: isResendDisabled ? "not-allowed" : "pointer",
                  textDecoration: "underline"
                }}
              >
                Resend Code
              </span>

              {isResendDisabled && (
                <span style={{ marginLeft: "10px", color: "red" }}>
                  ({Math.floor(timer / 60)}:
                  {String(timer % 60).padStart(2, "0")})
                </span>
              )}
            </p>

          </div>
        </div>
      </div>
      <footer className='bg-dark text-white text-center '>
        <label style={{ fontSize: "12px" }}>Copyright © 2026 NavGraph Technologies. All Rights Reserved.</label>
      </footer>
    </>

  );
}

export default Verify;